<div class="c-testerModal">
  <div class="c-testerModal__container">
    <div class="c-testerModal__content">
      <fieldset>
        <legend>User Lobby</legend>
        <div class="e-form">
          <form [formGroup]="showTestMachinesForm">
            <div class="e-form__field">
              <div class="e-form__element__row">
                <label>Show Test Machines</label>

                <label class="switch">
                  <input
                    type="checkbox"
                    formControlName="testMachines" />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </form>
        </div>

        <div class="e-form">
          <form [formGroup]="blockUserBuysForm">
            <div class="e-form__field">
              <div class="e-form__element__row">
                <label>Block User Buys</label>

                <label class="switch">
                  <input
                    type="checkbox"
                    formControlName="blockUserBuys" />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </form>
        </div>

        <div class="e-form">
          <form [formGroup]="versionForm">
            <div class="e-form__field">
              <div class="e-form__element__row">
                <label>Selecciona una versión</label>

                <slotcom-select
                  formControlName="selectedVersion"
                  placeholder="Selecciona una versión">
                  @for (version of versions; track version) {
                    <slotcom-select-option [value]="version">
                      {{ version }}
                    </slotcom-select-option>
                  }
                </slotcom-select>
              </div>
              <div class="e-form__element__button__row">
                <slotcom-button
                  [isDisabled]="!selectedVersion"
                  class="e-form__element__button__row c-button--pink"
                  (click)="onSubmitVersion()">
                  {{ 'home.buttons.go' | translate | uppercase }}
                </slotcom-button>
              </div>
            </div>
          </form>
        </div>
      </fieldset>

      <fieldset>
        <legend>Progress Line</legend>
        <div class="e-form">
          <form [formGroup]="incrementProgressLineForm">
            <div class="e-form__field">
              <div class="e-form__element__row">
                <label>Increment Progress Line!</label>

                <input
                  data-testid="slotcom-testerPanel-incrementProgressLine-inputText"
                  id="incrementProgressLine"
                  name="incrementProgressLine"
                  type="text"
                  formControlName="incrementProgressLineValue" />
              </div>
              <div class="e-form__element__button__row">
                <slotcom-button
                  [isDisabled]="!incrementProgressLineForm.get('incrementProgressLineValue')?.value"
                  class="e-form__element__button__row c-button--pink"
                  (click)="addPrestige()">
                  Increment
                </slotcom-button>
              </div>
            </div>
          </form>
        </div>
      </fieldset>

      <fieldset>
        <legend>User Games</legend>

        <div class="e-form">
          <form [formGroup]="unlockGameForm">
            <div class="e-form__field">
              <div class="e-form__element__row">
                <label>Select a game to unlock</label>
                <slotcom-select
                  formControlName="selectedUnlockGame"
                  placeholder="Select a game to unlock">
                  @for (game of sortedGames; track game.gameId) {
                    @if (!game.isUnlocked) {
                      <slotcom-select-option [value]="game.gameId">
                        {{ game.gameTitle }}
                      </slotcom-select-option>
                    }
                  }
                </slotcom-select>
              </div>
              <div class="e-form__element__button__row">
                <slotcom-button
                  [isDisabled]="!unlockGameForm.get('selectedUnlockGame')?.value"
                  class="c-button--pink"
                  (click)="unlockGame()">
                  Unlock
                </slotcom-button>
              </div>
            </div>
          </form>
        </div>

        <div class="e-form">
          <div class="e-form__field">
            <div class="e-form__element__row">
              <label>Unlock ALL games</label>
            </div>
            <div class="e-form__element__button__row">
              <slotcom-button
                class="c-button--pink"
                (click)="unlockAllGames()">
                Unlock
              </slotcom-button>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>Modify User Wallet</legend>

        <div class="e-form">
          <div class="e-form__field">
            <div class="e-form__element__row">
              <div
                class="e-form__field__copy__wallet__button"
                (click)="copyUserActualCoins()">
                <span> Copy User Actual</span>

                <div
                  theming
                  themingGroup="none"
                  themingAsset="credits"
                  class="e-form__field__icon"></div>
              </div>

              <label>Add Credits to User</label>

              <input
                data-testid="testerPanel-addResource-inputText"
                [(ngModel)]="addCoinsValue"
                id="addCoinsValue"
                name="addCoinsValue"
                type="number"
                maxlength="20" />

              <div
                class="e-form__field__icon"
                theming
                themingGroup="none"
                themingAsset="credits"
                data-testid="testerPanel-addCredits-button"
                (click)="addCoinsToUser()"></div>
            </div>
          </div>
        </div>
        <div class="e-form">
          <div class="e-form__field">
            <div class="e-form__element__row">
              <div
                class="e-form__field__copy__wallet__button"
                (click)="copyUserActualGems()">
                <span> Copy User Actual</span>

                <div
                  theming
                  themingGroup="none"
                  themingAsset="gems"
                  class="e-form__field__icon"></div>
              </div>

              <label>Add Credits to User</label>

              <input
                data-testid="testerPanel-addResource-inputText"
                [(ngModel)]="addGemsValue"
                id="addGemsValue"
                name="addGemsValue"
                type="number"
                maxlength="20" />

              <div
                class="e-form__field__icon"
                data-testid="testerPanel-addGems-button"
                theming
                themingGroup="none"
                themingAsset="gems"
                (click)="addGemsToUser()"></div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>Reset User Feature Values</legend>
        <div class="e-form">
          <div class="e-form__field">
            <div class="e-form__multiple__element__row">
              <div
                data-testid="testerPanel-goldenBomb-reset-button"
                class="e-form__field__icon"
                theming
                themingGroup="portal"
                themingAsset="bomb-animation"
                (click)="resetGoldenBomb()"></div>
              <div
                data-testid="testerPanel-recurringBonus-reset-button"
                class="e-form__field__icon"
                theming
                themingGroup="progressline"
                themingAsset="header-sachet-available"
                (click)="resetRecurring()"></div>
              <div
                data-testid="testerPanel-dailyBonus-reset-button"
                class="e-form__field__icon"
                theming
                themingGroup="portal"
                themingAsset="daily-bonus"
                (click)="setLastLoginYesterday()"></div>
              <div
                data-testid="testerPanel-highscore-reset-button"
                class="e-form__field__icon"
                theming
                themingGroup="portal"
                themingAsset="top-win-animation"
                (click)="resetHighScore()">
                <span>Top Win</span>
              </div>
              <div
                data-testid="testerPanel-resetLteStatuses-button"
                class="e-form__field__icon"
                theming
                themingGroup="portal"
                themingAsset="events-icon"
                (click)="deleteEventStatus()"></div>

              <div class="e-form__element__button__row">
                <slotcom-button
                  class="c-button--pink"
                  data-testid="testerPanel-resetAllUserValues-button"
                  (click)="resetAll()">
                  Reset All
                </slotcom-button>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>Change User Email</legend>
        <div class="e-form">
          <form [formGroup]="changeEmailForm">
            <div class="e-form__field">
              <div class="e-form__element__row">
                <label>New email</label>

                <input
                  data-testid="slotcom-testerPanel-email-inputText"
                  id="email"
                  name="email"
                  type="text"
                  maxlength="50"
                  formControlName="emailValue" />
              </div>
              <div class="e-form__element__button__row">
                <slotcom-button
                  class="c-button--pink"
                  (click)="updateUserEmail()">
                  Update
                </slotcom-button>
              </div>
            </div>
          </form>
        </div>
      </fieldset>
      <fieldset>
        <legend>Delete User Linked Logins</legend>

        <div class="e-form">
          <div class="e-form__field">
            <div class="e-form__multiple__element__row">
              <slotcom-button
                data-testid="testerPanel-delete-login-facebook-button"
                class="c-button--pink"
                (click)="deleteFacebookLogin()">
                Facebook
              </slotcom-button>
              <slotcom-button
                data-testid="testerPanel-delete-login-facebook-button"
                class="c-button--pink"
                (click)="deleteAppleLogin()">
                Apple
              </slotcom-button>
              <slotcom-button
                data-testid="testerPanel-delete-login-facebook-button"
                class="c-button--pink"
                (click)="deleteGooglePlayLogin()">
                Google Play
              </slotcom-button>
              <slotcom-button
                data-testid="testerPanel-delete-login-facebook-button"
                class="c-button--pink"
                (click)="deleteEmailLogin()">
                Email
              </slotcom-button>
              <slotcom-button
                data-testid="testerPanel-delete-login-facebook-button"
                class="c-button--pink"
                (click)="deleteGuestLogin()">
                Guest
              </slotcom-button>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</div>
